<app-search
	[searchId]="searchId"
	[criteriaValues]="criteriaValues"
	[allowSingleSelect]="allowSingleSelect"
	[searchOnLoad]="searchOnLoad"
	[showCriteria]="showCriteria"
	[criteriaExpandedOnLoad]="criteriaExpandedOnLoad"
	[canCustomizeView]="canCustomizeView"
	[canExport]="canExport"
	[hidePagination]="hidePagination"
	[searchState]="searchState"
	(rowClicked)="onRowClicked($event)"
	(criteriaFormInitialized)="onSearchStateChanged()"
	(searchFinished)="onSearchStateChanged()"
></app-search>
